import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { blogArticles } from "@/mocks/basetaoData";

export default function BlogPreviewSection() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-900 mb-3 text-center">
            Latest BaseTao Spreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
            In-depth articles and resources to help you master BaseTao Spreadsheet and make smarter purchasing decisions.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {blogArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                className="group block rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                    {article.tag}
                  </span>
                  <h4 className="font-heading font-semibold text-foreground-900 mb-2 text-base group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 mt-4 text-xs text-primary-500 font-medium">
                    <span className="whitespace-nowrap">Read Article</span>
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/shopping-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-200/70 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:border-primary-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              View All Guides
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}